import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";
import { title } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useAuditRemarksList() {
  //User toast
  const toast = useToast();

  const refAuditRemarkListTable = ref(null);

  const tableColumns = [
    { key: "name", label: "名稱", sortable: true },
    { key: "remark", label: "銷售備註" },
    { key: "action", label: "操作" },
  ];

  const perPage = ref(10);
  const totalAuditRemarks = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(false);

  const dataMeta = computed(() => {
    const localItemsCount = refAuditRemarkListTable.value
      ? refAuditRemarkListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalAuditRemarks.value,
    };
  });

  const refetchData = () => {
    refAuditRemarkListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery], () => {
    refetchData();
  });

  const fetchAuditRemarks = (ctx, callback) => {
    store
      .dispatch("setting-auditremark/fetchAuditRemarks", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        const { audit_remarks, total } = response.data;
        callback(audit_remarks);
        totalAuditRemarks.value = total;
      })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching audit methods list",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  return {
    fetchAuditRemarks,
    tableColumns,
    perPage,
    currentPage,
    totalAuditRemarks,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refAuditRemarkListTable,
    ability,
    refetchData,
  };
}
